(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function onVariantChange({target: optionValueElement}) {
    const productElement = this.querySelector('.product');
    const sectionId = this.dataset.sectionId;
    const oldProductUrl = productElement.dataset.productUrl;
    const newProductUrl = optionValueElement.dataset.productUrl;
    const newVariantId = optionValueElement.dataset.variantId;

    let params = `section_id=${sectionId}&`;
    if (newVariantId) {
      // If the option value has a variant selection, call the section rendering api for that variant
      params += `variant=${newVariantId}`;
    } else {
      // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
      const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;
    }

    // Call the section rendering api
    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        if (newProductUrl && oldProductUrl !== newProductUrl) {
          // If the product changed, replace the old product section with the new product section
          productElement.parentNode.insertBefore(html.querySelector('.product'), productElement);
          productElement.remove();

          // Focus the input for the last clicked option value
          this.querySelector(`#${optionValueElement.id}`).focus();

          // Update anything else that depends on product, such as URL and recommended products
          return;
        }

        this.querySelector('.optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;
        this.querySelector(`#${optionValueElement.id}`).focus();

        const priceEl = this.querySelector('.price');
        if (hasVariant) {
          priceEl.innerHTML = html.querySelector('.price').innerHTML;
          // Update any additional states here
        } else {
          priceEl.innerHTML = '';
          // Set additional unavailable states here
        }
      });
  }

  document.getElementById('productSection').addEventListener('change', onVariantChange);

  } catch(e) { console.error(e); }
})();
})();
